import React from "react";
import TextInput from "../../Components/Inputs/TextInput";
import TextareaInput from "../../Components/Inputs/TextareaInput";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import ImageInput from "../../Components/Inputs/ImageInput";
import NumberInput from "../../Components/Inputs/NumberInput";

export default function ({register, errors, control, data, watch}) {

  return (
    <>
      <ImageInput
        name="icon"
        label="Icon (Recomended: SVG)"
        parentClasses="col-xl-4 col-sm-12"
        classes="d-inline-block"
        id="IconUpload"
        register={register}
        control={control}
        errorMessage={errors?.icon}
      />
      <ImageInput
        name="image"
        parentClasses="col-xl-4 col-sm-5 offset-xl-0 offset-sm-1"
        classes="d-inline-block"
        id="imageUpload"
        register={register}
        control={control}
        errorMessage={errors?.image}
      />
      <ImageInput
        name="image_responsive"
        label="Image Responsive (Recomended: SVG)"
        parentClasses="col-xl-4 col-sm-5"
        classes="d-inline-block"
        id="imageResponsiveUpload"
        register={register}
        control={control}
        errorMessage={errors?.image_responsive}
      />
      <TextInput
        label="Name"
        name="name"
        register={register}
        required={true}
        errorMessage={errors?.name}
      />
      <TextareaInput
        label="Description"
        name="description"
        register={register}
        required={false}
        rows={3}
        event={true}
        eventName="Characters"
        watch={watch}
        errorMessage={errors?.description}
      />

      <TextareaInput
        label="Keywords"
        name="keywords"
        register={register}
        required={false}
        rows={3}
        event={true}
        watch={watch}
        errorMessage={errors?.keywords}
      />

      <div className="text-muted fs-7 mb-5">
        Set keywords to the category separated by comma ( ex: word1, word2, word3 )
      </div>

      <TextInput
        label="Code"
        name="code"
        register={register}
        required={true}
        errorMessage={errors?.code}
      />

      <NumberInput
        label="Position"
        name="order_by"
        register={register}
        errorMessage={errors?.order_by}
      />

      <ReactSelectInput
        label="Parent Category (If has one)"
        name="parent_id"
        placeholder="Choose parent category"
        register={register}
        options={data?.categories}
        errorMessage={errors?.parent_id}
        control={control}
      />

      <ReactSelectInput
        label="Delivery provider"
        name="delivery_provider"
        placeholder="Choose delivery provider"
        options={data?.deliveryProviders}
        errorMessage={errors?.delivery_provider}
        control={control}
        inputClassName='mt-5'
      />
    </>
  );
}